<template>
  <el-row class="second-frame" type="flex" justify="space-between">
    <el-col :span="8" class="first">
      <div class="title">
        <div class="num">1</div>
        <span>Прямые контракты от экспортера</span>
      </div>
      <ul>
        <li>
          <span>
            Договора с 6 Экспортерами<br />
            <span>из топ 10</span>
          </span>
        </li>
        <li>Заказы на 100 авто в день</li>
        <li>И мы растем с каждым днем</li>
      </ul>
    </el-col>
    <el-col :span="8" class="second">
      <div class="title">
        <div class="num">2</div>
        <span>Наша комиссия<br />1 рубль с тонны</span>
      </div>
      <ul>
        <li>Экспортер устанавливает цену 1000 руб/тонн</li>
        <li>Мы платим исполнителю 999 руб/тонн</li>
        <li>Наша комиссия с рейса не более 30 рублей</li>
      </ul>
    </el-col>
    <el-col :span="8" class="third">
      <div class="title">
        <div class="num">3</div>
        <span>С нами удобно</span>
      </div>
      <ul>
        <li>с 10 ноября подпись всех документов в телефоне</li>
        <li>Мы платим в течение 3 рабочих дней после сдачи ТТН</li>
        <li>
          Загрузите 1 раз документы в приложение и становитесь в рейс в 3
          нажатия на телефоне
        </li>
      </ul>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'SecondFrame',
}
</script>

<style lang="sass">
.second-frame
  font-family: 'Roboto', sans-serif;
  padding: 140px 60px;
  text-align: center;
  background-color: #fff;
  height: 100%;
  .title
    align-items: center;
    display: flex;
    background-color: #333;
    height: 120px
    border-radius: 60px;
    font-size: 36px;
    color: #E0E0E0;
    .num
      width: 120px;
      height: 120px;
      background-color: #02b8b9;
      align-items: center;
      display: flex;
      justify-content: center;
      border-radius: 50%
      font-size: 90px;
      color: #fff;
      font-weight: bold;
    span
      width: 420px;
  ul
    list-style: none;
    padding: 0;
    margin: 100px auto 0;
    position: relative;
    overflow: hidden;
    li
      width: 450px;
      height: 150px;
      margin-right: 30px;
      margin-top: 25px;
      font-size: 32px;
      align-items: center;
      display: flex;
      padding: 10px;
      box-sizing: border-box;
      float: right;
      &:first-child
        margin-top: 0;
  .el-col
    width: 550px;
    &.first
      ul:before
        content: '';
        position: absolute;
        width: 50px;
        height: 600px;
        background-image: url("~@/assets/img/promo-line.svg");
        background-size: cover;
        left: 0;
      li
        border: 4px solid #02B8B9
        color: #007B7B;
        span span
          font-weight: bold;
          font-size: 36px;
        &:last-child
          font-size: 36px;
        &:nth-child(2)
          font-size: 46px;
    &.second
      .num
        background-color: #FF843F;
      li
        border: 4px solid #FF843F;
        font-weight: bold;
    &.third
      .num
        background-color: #2ECC71;
      span
        font-size: 54px;
      li
        border: 4px solid #2ECC71;
        font-weight: bold;
        color: #3C9762;
        &:last-child
          font-size: 28px;
</style>
